import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { LegalLayout } from "@/pages/legal/LegalLayout";

export default function Privacy() {
  useSEO({
    title: "Privacy Policy | E Telecom",
    description: "Read E Telecom's Privacy Policy covering how information is collected, used and protected across our communication services.",
    path: "/privacy-policy",
  });

  return (
    <LegalLayout title="Privacy Policy" updated="Last updated: 2026">
      <p>This Privacy Policy explains how E Telecom (“we”, “us”, “our”) collects, uses and protects information when you use our website and communication services. By using our services, you agree to the practices described here.</p>

      <h2>Information We Collect</h2>
      <p>We may collect information you provide directly, such as your name, company, email, phone number and details submitted through our contact or quote forms. We may also collect limited technical information (such as device and usage data) to operate and improve our website.</p>

      <h2>How We Use Information</h2>
      <ul>
        <li>To respond to enquiries and provide requested information.</li>
        <li>To deliver, maintain and improve our communication services.</li>
        <li>To communicate with you about your requests, service updates and support.</li>
        <li>To comply with applicable legal and regulatory requirements.</li>
      </ul>

      <h2>Communication & Consent</h2>
      <p>E Telecom supports responsible, permission-based communication. Where our services are used to send messages to end recipients, our customers are responsible for obtaining appropriate consent and complying with applicable laws and platform policies.</p>

      <h2>Data Sharing</h2>
      <p>We do not sell your personal information. We may share information with trusted service providers who help us operate our services, subject to appropriate confidentiality obligations, or where required by law.</p>

      <h2>Data Security</h2>
      <p>We take reasonable technical and organisational measures to protect information. However, no method of transmission or storage is completely secure.</p>

      <h2>Your Choices</h2>
      <p>You may request access to, correction of, or deletion of the personal information you have provided, subject to applicable law. You can also opt out of non-essential communication.</p>

      <h2>Contact</h2>
      <p>For any privacy-related questions, contact us at info@etelecom.in.</p>

      <p className="text-sm text-slate-500">This Privacy Policy is provided for general informational purposes and does not constitute legal advice. Please consult a qualified professional for specific compliance requirements.</p>
    </LegalLayout>
  );
}
